var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 16.8333H12.8333V14.5H4.66667V16.8333ZM4.66667 12.1667H16.3333V9.83333H4.66667V12.1667ZM4.66667 7.5H16.3333V5.16667H4.66667V7.5ZM2.33333 21.5C1.69167 21.5 1.14236 21.2715 0.685417 20.8146C0.228472 20.3576 0 19.8083 0 19.1667V2.83333C0 2.19167 0.228472 1.64236 0.685417 1.18542C1.14236 0.728472 1.69167 0.5 2.33333 0.5H18.6667C19.3083 0.5 19.8576 0.728472 20.3146 1.18542C20.7715 1.64236 21 2.19167 21 2.83333V19.1667C21 19.8083 20.7715 20.3576 20.3146 20.8146C19.8576 21.2715 19.3083 21.5 18.6667 21.5H2.33333ZM2.33333 19.1667H18.6667V2.83333H2.33333V19.1667Z",
    fill: "#0094FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.7de91b77f3b245f291a88207cd0e209e.svg";
export { ForwardRef as ReactComponent };